"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORCE_WRITE_API_URLS = exports.DEFAULT_API_URL = exports.PUBLIC_METADATA_KEY = void 0;
exports.PUBLIC_METADATA_KEY = '__metadata';
exports.DEFAULT_API_URL = 'www.wixapis.com';
exports.FORCE_WRITE_API_URLS = ['/ecom/v1/carts/current'];
